export const OrdersHistoryPageTemplate = {
    slots: ['SlbOrderHistoryContainerSlot'],
};